import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { AppErrorBoundary } from "./app/components/AppErrorBoundary";
import { installGlobalErrorReporting } from "./app/data/report-error";
import "./styles/index.css";

installGlobalErrorReporting();

// Each deploy replaces the hashed chunk files, so a tab opened before the
// deploy can request chunks that no longer exist. Vite fires this event when
// a dynamic import's preload fails — reload once to pick up the new build.
// The timestamp guard stops a reload loop if the failure is something else;
// in that case the error propagates to the router's error screen instead.
window.addEventListener("vite:preloadError", (event) => {
  const lastReload = Number(sessionStorage.getItem("sf-chunk-reload") || 0);
  if (Date.now() - lastReload > 30_000) {
    sessionStorage.setItem("sf-chunk-reload", String(Date.now()));
    event.preventDefault();
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);
